// this file gets replaced with the real value during the build
const Version = '6.8.4';

export { Version as default };
